import { observable } from "mobx";
import { Type } from "class-transformer";
import DateRangeRequest from "./dateRangeRequest";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SubLedgerReportChargeOrderRequest {
  id?: string;

  @observable
  orderIdent?: number;

  @observable
  @Type(() => DateRangeRequest)
  createdDate?: DateRangeRequest;

  @observable
  licensePlate?: string;

  @observable
  countryId?: string;

  /**
   * Email.
   * @example
   * test@example.com
   */
  @observable
  email?: string;

  @observable
  chargeId?: string;

  @observable
  salespointId?: string;

  @observable
  kioskId?: string;
}

export class SubLedgerReportChargeOrderRequestX extends SubLedgerReportChargeOrderRequest {
  @observable id?: string;
}

export const SubLedgerReportChargeOrderRequestValidationRules: EntityValidationRules<SubLedgerReportChargeOrderRequest> = {
  email: {
    isEmail: { required: false },
  },
  id: {
    isLength: {
      min: 32,
      max: 36,
      optional: true,
    },
  },
  licensePlate: {
    isLicensePlate: {
      required: false,
    },
    isLength: {
      min: 1,
      optional: true,
    },
  },
  chargeId: {
    isLength: {
      min: 32,
      max: 36,
      optional: true,
    },
  },
  orderIdent: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
};
